function isTie(winStr: string) {
	const [redValue, blueValue] = [
		getRedValue(winStr),
		getBlueValue(winStr)
	];

	return redValue > 0 && redValue === blueValue;
}

function getRedValue(winStr: string) {
	return Number(winStr?.match(/\d/g)[0]);
}

function getBlueValue(winStr: string) {
	return Number(winStr?.match(/\d/g)[1]);
}

function getDiceSum(winStr: string) {
	return Number(
		winStr?.match(/\d/g)
			.map(n => Number(n))
			.reduce((a, b) => a + b, 0)
	);
}

function isRedWin(winStr: string) {
	return getRedValue(winStr) > getBlueValue(winStr);
}

function isBlueWin(winStr: string) {
	return getBlueValue(winStr) > getRedValue(winStr);
}


function isRedLow(winStr: string) {
	const redValue = getRedValue(winStr);
	return redValue > 0 && redValue <= 3;
}

function isRedHigh(winStr: string) {
	return getRedValue(winStr) > 3;
}

function isRedOdd(winStr: string) {
	return getRedValue(winStr) % 2 > 0;
}

function isRedEven(winStr: string) {
	const redValue = getRedValue(winStr);
	return redValue > 0 && redValue % 2 === 0;
}


function isBlueLow(winStr: string) {
	const blueValue = getBlueValue(winStr);
	return blueValue > 0 && blueValue <= 3;
}

function isBlueHigh(winStr: string) {
	return getBlueValue(winStr) > 3;
}

function isBlueOdd(winStr: string) {
	return getBlueValue(winStr) % 2 > 0;
}

function isBlueEven(winStr: string) {
	const blueValue = getBlueValue(winStr);
	return blueValue > 0 && blueValue % 2 === 0;
}

/**
 * only for grey area
 * @returns an array of numbers if winStr is defined, otherwise an empty array
 */
function getWinDices(winStr: string) {
	return winStr
		? winStr.match(/\d/g).map(num => Number(num))
		: [];
}


export {
	getBlueValue, getDiceSum, getRedValue,

	isRedWin, isTie, isBlueWin,

	isRedLow, isRedHigh, isRedOdd, isRedEven,
	isBlueLow, isBlueHigh, isBlueOdd, isBlueEven,

	getWinDices
};